import { Row } from "../models/shipeezi.table";

export const saveRowsSelectedFromTable = (selected: number[], rows: Row[], data: any): Row[] => {
  let rowsSelected: Row[] = [];

  if (rows.length > selected.length) {
    rowsSelected = rows;
    rows.forEach((row) => {
      if (row.id && !selected.includes(row.id)) {
        const index = rowsSelected.findIndex((rowS) => rowS.id === row.id);

        rowsSelected.splice(index, 1);
      }
    });
  } else {
    selected.forEach((rowId) => {
      if (rows.length > 0) {
        rowsSelected = rows;
      }
      const included = rowsSelected.map((row) => row.id);

      if (!included.includes(rowId)) {
        const findRow = data.find((item: any) => item.id === rowId);

        if (findRow) {
          rowsSelected.push(findRow);
        }
      }
    });
  }

  return rowsSelected;
};
